import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { SIGNOUT } from 'redux/sagas/actions/authentication';
import { MODAL_CLOSE } from 'redux/slices/modals';
import Button from 'ui/atoms/Button';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';

import Modal, { stopEvent } from '../Modal';
import { ModalGlobalContainer, ModalTitle, ModalWrapper } from '../Modal.style';
import { LogoutButton, LogoutText } from './style';

const modalId = 'LogoutModal';

const Logout = ({ onClose, signOut, user }) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer onMouseDown={stopEvent} onClick={stopEvent}>
            <ModalTitle>
              <MainFont configuration={{ fontSize: 24 }} type="4">
                {t('logout')}
              </MainFont>
            </ModalTitle>

            <LogoutText>
              <MainFont configuration={{ fontSize: 16 }}>
                {t('logout_message')} {user?.attributes?.email}?
              </MainFont>
            </LogoutText>
            <LogoutButton>
              <Button variant="popupCancel" onClick={onClose}>
                {t('no_wait')}
              </Button>
              <Button variant="popupYes" onClick={signOut}>
                {t('logged_me_out')}
              </Button>
            </LogoutButton>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

Logout.propTypes = {
  signOut: PropTypes.func,
  onClose: PropTypes.func,
  user: PropTypes.object
};
Logout.id = modalId;

export default connect(
  state => ({
    user: state?.authentication?.user
  }),
  dispatch => ({
    onClose: () => dispatch(MODAL_CLOSE()),
    signOut: () => dispatch({ type: SIGNOUT._REQUEST })
  })
)(Logout);
